import { IDictionary } from '~utilities/IDictionary';
import RiskBandEnum from './RiskBandEnum';

export const riskBandLabels: IDictionary<string> = {
    [RiskBandEnum.BandOne]: 'Cat 1',
    [RiskBandEnum.BandTwo]: 'Cat 2',
    [RiskBandEnum.BandThree]: 'Cat 3',
    [RiskBandEnum.BandZero]: 'Cat 0',
};
